import '../../../js/core.js';
import '../../../js/video-youtube-iframe.js';
import '../../../../../../assets2/components/site-elements/sliders/sliders.scss';
import '../../ui-components/bootstrap/modal-video.scss';
import './page-home.less';

import setBlogSubscribeModalHandlers from '../../../js/modals/setBlogSubscribeModalHandlers';

setBlogSubscribeModalHandlers('#modalSubscribeSent');



$(function () {
  import('owl.carousel/src/js/owl.carousel').then(() => {
    import('owl.carousel/src/js/owl.navigation').then(() => {

        jQuery('.js-partners-slider').owlCarousel({
          responsive: {
            568: {
              items: 3,
              slideBy: 1,
            },

            768: {
              items: 3,
              slideBy: 1,
              margin: 24,
            },
          },
          nav: true,
          dots: false,
          items: 2,
          slideBy: 1,
          loop: true,
          margin: 18
        });

        jQuery('.js-industries-slider').owlCarousel({
          responsive: {
            0: { items: 1, dots: false },
            480: { items: 2, slideBy: 2 },
            680: { items: 3, slideBy: 3 },
            900: { items: 4, slideBy: 4 },
          },
          nav: true,
          loop: true,
          dots: true,
          margin: 24,
          slideBy: 1
        });

        jQuery('.js-citation-slider').owlCarousel({
          responsive: {
            0: { items: 1, dots: false },
            480: { items: 1 },
          },
          nav: true,
          loop: true,
          dots: true,
          margin: 24,
          slideBy: 1
        });

        jQuery('.js-recognitions-slider').owlCarousel({
          responsive: {
            0: {
              items: 1,
            },

            568: {
              items: 2,
            },
            1024: {
              items: 3,
            },
            1280: {
              items: 4,
            },
          },
          nav: true,
          items: 1,
          dots: false,
          slideBy: 1,
          loop: false,
          margin: 20,
        });
        
        $('.owl-carousel').each(function(index) {
            $(this).find('.owl-nav, .owl-dots').wrapAll("<div class='owl-controls'></div>");
        });

    });
  });
});

$(function () {
  $('.modal').on('show.bs.modal', function (event) {
    $(this).find('iframe').attr("src", $(event.relatedTarget).data('url'));
  });

  $('.modal').on('hidden.bs.modal', function (e) {
    $(this).find('iframe').attr("src", "");
  });
});